import { ticketClient } from "@/api/index";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import { 
  DialerAutoStartReq,
  DialerAutoStopReq, 
  DialerAutoNextReq,
  DialerCurrentInfoReq
} from "@/pbjs/xcommon/ticket_pb";
// lee 绩效接口参数
interface Options {
  supplie?: any;
}
// DialerAutoStart dialer开始呼叫
export function dialerAutoStart(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new DialerAutoStartReq();
      request.setCommonin(setCommon());
      request.setSupplier(arg.supplie)
      // setRank
      let _res = await ticketClient.dialerAutoStart(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
// DialerAutoStop dialer停止呼叫
export function dialerAutoStop(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new DialerAutoStopReq();
      request.setCommonin(setCommon());
      request.setSupplier(arg.supplie)
      // setRank
      let _res = await ticketClient.dialerAutoStop(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
// DialerAutoNext dialer呼叫下一个
export function dialerAutoNext(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new DialerAutoNextReq();
      request.setCommonin(setCommon());
      // setRank
      let _res = await ticketClient.dialerAutoNext(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
// 呼叫当前信息
export function dialerCurrentInfo(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new DialerCurrentInfoReq();
      request.setCommonin(setCommon());
      // setRank
      let _res = await ticketClient.dialerCurrentInfo(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
